var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnFavoriteSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54332 1.02453C7.7195 0.629286 8.2805 0.629285 8.45668 1.02453L10.0927 4.69469C10.1653 4.85771 10.3194 4.96963 10.4969 4.98837L14.4929 5.41013C14.9233 5.45555 15.0966 5.9891 14.7752 6.27879L11.7902 8.96884C11.6576 9.08833 11.5988 9.26942 11.6358 9.44401L12.4695 13.3748C12.5593 13.7982 12.1055 14.1279 11.7306 13.9117L8.24981 11.9041C8.09521 11.8149 7.90479 11.8149 7.75019 11.9041L4.26939 13.9117C3.89454 14.1279 3.44067 13.7982 3.53046 13.3748L4.36419 9.44401C4.40122 9.26942 4.34238 9.08833 4.2098 8.96884L1.22481 6.27879C0.903354 5.9891 1.07671 5.45555 1.50706 5.41013L5.50314 4.98837C5.68063 4.96963 5.83467 4.85771 5.90734 4.69469L7.54332 1.02453Z",
    fill: "#172664"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnFavoriteSelected);
export default __webpack_public_path__ + "static/media/icn_favorite_selected.013943f47e13940c4e455e6154b44d24.svg";
export { ForwardRef as ReactComponent };